// Area pages at /tmd-physio-{slug}. Researched, written and fact-checked copy
// comes from the area pipeline (backend/scripts/area_pipeline → ./generated).
import generated from './generated/areas.json';

export const AREA_ORDER = [
  'waterloo-south-bank', 'lambeth-kennington', 'southwark-borough-london-bridge', 'westminster-victoria',
  'elephant-and-castle', 'pimlico', 'bloomsbury', 'fitzrovia', 'holborn', 'marylebone', 'kings-cross',
  'covent-garden', 'city-of-london', 'shoreditch', 'farringdon', 'soho', 'angel-islington', 'hatton-garden',
  'clapham', 'balham', 'brixton', 'dulwich', 'wimbledon', 'richmond-petersham',
];

export const boroughs = AREA_ORDER
  .filter((slug) => generated[slug])
  .map((slug) => ({ ...generated[slug], generated: true }))
  .map((b) => ({ ...b, borough: b.name }));

export const boroughsBySlug = Object.fromEntries(boroughs.map((b) => [b.slug, b]));

export const DEFAULT_SPECIALIST_POINTS = [
  { title: '15+ years in focus', body: 'Krina has spent more than 15 years focused on TMD, headache and tinnitus.' },
  { title: 'Specialist TMD training', body: 'A University of Liverpool Masters module in TMD, a Columbia University Orofacial Pain Clinic placement, and courses with Steve Kraus, CRAFTA®, Watson Headache® and Instituto Rocabado.' },
  { title: 'A published standard of care', body: 'The TMD Physio Standard sets out how you will be assessed and treated: jaw, neck and nerves together, with goals reviewed at each visit.' },
  { title: 'Technology inside a plan', body: 'NESA neuromodulation, low-level laser, dry needling and TMJ Velvet radiofrequency & diathermy, used only where the evidence supports it.' },
];

export const DEFAULT_MASSAGE_BLOCK = {
  title: 'The Signature Jaw Massage',
  body: 'Designed by Krina and delivered by Krina or a therapist personally trained in her protocol: an anatomy-led jaw, face, scalp and neck massage in a warm, unhurried room. A wellness experience, not a medical treatment.',
};
